<template>
  <div id="home">
    
      <v-container>
        <div class="home-hero">
            <img src="../../static/images/dd-blue.svg">
            <h1>A website builder,</h1>
            <h1>tailored for you</h1>
         </div>
         <div class="home-products">
         <v-layout row>
          <v-flex xs12>
         
               <h2>Dealer Draft products</h2>
               <div class="line-below"></div>
             </v-flex>
           </v-layout>
           <v-layout row wrap>
             <v-flex xs12 sm6 pr-3>
               <div class="product-box">
                 <img src="../../static/images/home-build-img.png">
                <h3>Homepage builder</h3>
                <router-link to="/builder">
                  <v-btn depressed large>Start building</v-btn>
                </router-link>
               </div>
             </v-flex>
             <v-flex xs12 sm6 pl-3>
               <div class="product-box">
                 <img src="../../static/images/srp-build-img.jpg">
                <h3>SRP builder</h3>
                <router-link :to="{name: 'SRPBuilder'}">
                  <v-btn depressed large>Start building</v-btn>
                </router-link>
               </div>
             </v-flex>
           </v-layout>
         </div>
         
            
      </v-container>
   
  </div>
</template>

<script>
  export default {
    mounted () {
      window.scrollTo(0, 0);
      document.getElementById('app').scrollIntoView();
    }
  }
</script>

<style scoped>
  #home {
    min-height: calc(100vh - 100px);
  }
  #home .home-hero {
    background-image: url("../../static/images/home-hero.png");
    background-size: cover;
    background-position: center;
    min-height: 500px;
    padding: 50px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  #home .home-hero h1 {
    font-weight: 400;
    color: #fff;
    font-size: 4rem;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
  }
  #home .home-products {
    padding-top: calc(3% + 30px);
    padding-bottom: calc(5% + 30px);
  }
  #home .home-products h2 {
    font-size: 2rem;
  }
  #home .line-below {
    height: 1px;
    width: 100%;
    margin: 15px auto 30px;
    background-color: #E6E6E6;
  }
  #home .home-products .product-box img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    margin: 10px auto 25px;
  }
  #home .home-products h3 {
    font-size: 1.8rem;
  }
  #home button {
    margin-left: 5px;
    margin-top: 30px;
    background: #006AFF;
    color: #fff;
    border: 2px solid #006AFF;
    font-size: 18px;
    font-weight: 400;
    text-transform: capitalize;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
  }
  #home button:hover {
    background: #fff;
    color: #006AFF;
  }
  #home .v-btn--active:before, #home .v-btn:hover:before, #home .v-btn:focus:before {
    background-color: #fff;
  }
  #home .home-hero img {
    max-width: 60px;
    margin-bottom: 30px;
  }

  @media (max-width: 1263px) {
    #home .home-hero h1 {
      font-size: 3.5rem;
    }
  }

  @media (max-width: 599px) {
    #home .home-hero h1 {
      font-size: 2.5rem;
    }
    #home .home-products .pr-3, #home .home-products .pl-3 {
      padding: 0px !important;
    }
    #home .home-products .pl-3 {
      margin-top: 30px;
    }
  }
</style>